Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.WordsCloudView extends Backbone.View

  className: 'words-cloud'
  template: JST['backbone/templates/monitoring/reports/daily_insights/words_cloud']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template(height: @options.cloudHeight, padding: @options.cloudPadding))

    ancestors = [@options.post.id]
    if @options.post.type == "instagramMedia"
      ancestors = @options.post.id.substring(0, @options.post.id.indexOf('-'))
      
    params = {
      account_id: @options.account_id,
      ancestors: ancestors,
      not: { sub_type: ['retweet'] },
      ngrams_limit: 20,
      exclude_page_owner_generated: true
    }
    @$el.addClass('rendering')

    job = new Monitoring.Methods.AsyncJob()
    job.bind('completed', @_renderCloud)
    job.start('words', params)

  _renderCloud: (data) =>
    renderer = new Monitoring.Methods.RenderWordCloud(data, {
      backgroundColor: 'rgba(255,255,255,0)',
      text_max_length: 20,
      max_size: 43,
      min_size: 25,
      filter_urls: true
    })
    if renderer.data.length == 0 
      @removeProcessingClasses()
      @$el.find("canvas").hide()
      @$el.find(".no-data").show()
      return

    renderer.renderInElement(@el.querySelector('canvas'))

    @removeProcessingClasses()

  removeProcessingClasses: =>
    @$el.find(".processing").removeClass('processing')
    @$el.removeClass('rendering')